import styled from '@emotion/styled';
import { rem } from '@mantine/core';

export const Wrapper = styled.main`
  background-color: white;

  .image-uploading.hidden {
    display: none;
  }

  .tags-container {
    max-width: 82.5rem;
    padding: 30px;
    margin: auto;
    color: black;
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-direction: column;
    margin-top: 20px;

    & > div {
      justify-content: center;
    }

    h2 {
      color: #161616;
      font-size: ${rem(30)};
      font-weight: 700;
    }

    a {
      background-color: rgba(74, 74, 74, 0.1);
      color: #161616;
    }
  }
`;

export const Content = styled.div`
  max-width: 82.5rem;
  margin: auto;
  width: 100%;

  * {
    color: black !important;
  }

  a {
    background-color: transparent !important;
  }

  div.video-container {
    padding: 30px 30px 0px 30px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 6px;

    div.thumbnail {
      max-width: 600px;
      width: 100%;
      position: relative;
      border-radius: 20px;
      overflow: hidden;
      aspect-ratio: 16 / 9;
      margin: auto;
      transition: all 0.2s;

      :hover {
        filter: brightness(0.8);
      }

      button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        border: none;
        background-color: #00000080;
        width: 100%;
        aspect-ratio: 16 / 9;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      img {
        object-fit: cover;
      }
    }
  }

  div.ql-editor {
    width: 100%;
    padding: 30px;

    p {
      font-size: ${rem(16)};
      font-weight: 400;
    }

    img {
      display: block;
      margin: auto;
      object-fit: cover !important;
      object-position: center !important;
      max-width: 100%;
    }

    iframe {
      margin: auto;
      display: block;
      width: 600px;
      aspect-ratio: 16 / 9;
    }
  }
`;
